import React from 'react';
import { Link } from 'react-router-dom';

import './Sidebar.scss';

export const Sidebar = ({ className, auth, logout }) => (
  <div className={className}>
    <h5 className='section'>Zombie</h5>
    {auth.token && (
      <div>
        <h5 className='section'>Submissions</h5>
        <ul>
          <li>
            <Link to='/submissions/new'>New submissions</Link>
          </li>
        </ul>

        <h5 className='section'>Reviewed</h5>
        <ul>
          <li>
            <Link to='/reviews'>My Reviews</Link>
          </li>
        </ul>
        <div className='logout'>
          <h5 className='section'>
            <ul>
              <li>
                <Link onClick={logout} to='/'>
                  Log out
                </Link>
              </li>
            </ul>
          </h5>
        </div>
      </div>
    )}
  </div>
);
